var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('v-row',{staticClass:"justify-end px-3"},[_c('AuthenticationMenu')],1)],1),_c('v-main',{staticClass:"ma-3"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }